import { IProductNew } from 'interfaces/product';
import { BehaviorSubject } from 'rxjs';
export class ScriptElementsService {
  private selectedProduct$ = new BehaviorSubject<IProductNew>(null);

  public setSelectedProduct(product: IProductNew) {
    this.selectedProduct$.next(product);
  }

  public getSelectedProduct() {
    return this.selectedProduct$.asObservable();
  }
}

export const ScriptElementsServiceFactory = () => new ScriptElementsService();

export const scriptElementsService = ScriptElementsServiceFactory();
